import { type FunctionComponent } from "react";

import { PageSpinner } from "@moment/design-system/PageSpinner";

export type LoadingScreenProps = Record<string, never>;

export const LoadingScreen: FunctionComponent<LoadingScreenProps> = () => {
	return <PageSpinner message="Loading" />;
};
